/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizeraboutgerman2Inputs */

const en_organizeraboutgerman2 = /** @type {(inputs: Organizeraboutgerman2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In German`)
};

const de_organizeraboutgerman2 = /** @type {(inputs: Organizeraboutgerman2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Deutsch`)
};

/**
* | output |
* | --- |
* | "In German" |
*
* @param {Organizeraboutgerman2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizeraboutgerman2 = /** @type {((inputs?: Organizeraboutgerman2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizeraboutgerman2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizeraboutgerman2(inputs)
	return de_organizeraboutgerman2(inputs)
});
export { organizeraboutgerman2 as "organizerAboutGerman" }